import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Animated } from "react-animated-css";
import { Card, Row, Col, Button, Descriptions, Image, Progress, Badge, Popconfirm, message, Statistic } from 'antd';
import { EditOutlined, ArrowLeftOutlined, DeleteOutlined } from '@ant-design/icons';
import { pathOr } from 'ramda';
import moment from 'moment';
import Ink from 'react-ink';

import './orderdetail.css';

import {
	opensearchAdImpressionIdSpecific,
	opensearchCtaClickAdIdSpecific,
	advertisementGetPackage,
	advertisementGetOrder,
	advertisementOrderDelete,
} from '../../modules/advertisement';
import AddPackage from '../../components/advertisement/modal/addpackage';

class OrderDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            advertisement: null,
            order: null,
			isModalShow: false,
			orderId: this.props.match.params.id,
			packageId: null,
			opensearchLoading: true,
			numImpression: false,
			numClick: false,
        };
    }

    async componentDidMount() {
        const { advertisement, order } = pathOr({}, ['props', 'location', 'state'], this);
        const { advertisementOrderList} = this.props;
		const { orderId } = this.state;
		this.setState({advertisement, order});
		if (!advertisementOrderList){
			this.props.advertisementGetOrder().then(res => {
				let target = res.find(d => d._id === orderId);
				this.setState({ order: target, packageId: target && target.package }, () => {
					this.getAdvertisementPackageList();
				});
			})
		}
    }

    async componentDidUpdate(prevProps, prevState) {
        const { advertisementOrderList,inspectionTime } = this.props;
		const { order } = this.state;
		if((JSON.stringify(prevState.order) !== JSON.stringify(order) && order && order.assetId) || JSON.stringify(prevProps.inspectionTime)!==JSON.stringify(inspectionTime)){
			this.opensearchGetImpression();
			this.opensearchGetClick();
		}
		if(!advertisementOrderList && JSON.stringify(advertisementOrderList) !== JSON.stringify(prevProps.advertisementOrderList)){
			this.setState({ loadingOrder: true });
			await this.props.advertisementGetOrder();
			this.setState({ loadingOrder: false });
		}
    }

	opensearchGetImpression = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		const { order } = this.state;
		this.setState({opensearchLoading: true})
		this.props.opensearchAdImpressionIdSpecific(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`, order.assetId).then(res => {
			if (res[0]) {
				this.setState({ numImpression: res[0].doc_count });
			}
			this.setState({opensearchLoading: false})
		})
	}

	opensearchGetClick = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		const { order } = this.state;
		this.setState({opensearchLoading: true})
		this.props.opensearchCtaClickAdIdSpecific(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`, order.assetId).then(res => {
			if (res[0]) {
				this.setState({ numClick: res[0].doc_count });
			}
			this.setState({opensearchLoading: false})
		})
	}

	getAdvertisementPackageList = async () => {
		const { packageId } = this.state;
		this.setState({ loadingactiveusers: true });
		await this.props.advertisementGetPackage().then(res => {
			this.setState({advertisement: res.find(d => d.packageId === packageId)});
		})
		this.setState({ loadingactiveusers: false });

	}

    backToPackage = () => {
		this.props.history.push('/advertisement', {
			advertisement: this.state.advertisement,
		});
	}

	toggleModal = (type, from) => {
		const { isModalShow } = this.state;
		if(isModalShow){
			this.props.advertisementGetOrder().then(res => {
				this.setState({ order: res.find(d => d._id === this.state.orderId) });
			})
		}
		this.setState({ isModalShow: !isModalShow });
	}

	confirmDeleteOrder = () => {
		this.props.advertisementOrderDelete(this.state.orderId)
		.then(() => {
			this.props.advertisementGetOrder().then((res) => {
				this.backToPackage()
			})
			message.success('Remove order successfully');
		}).catch(() => {
			message.error('Fail to remove order');
		})
	}

    render() {
        const { advertisement, order, isModalShow, numImpression, numClick, opensearchLoading } = this.state;
		const { userProfile } = this.props;
        let canEdit = (userProfile && userProfile.user && userProfile.user.access.includes('advertisement:editor')) ? true : false;
		const orderItems = order && [
			{ 
				key: "name",
				label: "Name",
				children: order.name,
				span: 2,
			},
			{
				key: "contact",
				label: "Contact",
				children: order.contact
			},
			{
				key: "budget",
				label: "Budget (inventory, Count = Budget/CPM*1000)",
				children: order.free ? '-' : order.budget,
				span: 3,
			},
			{
				key: "invertory",
				label: "Invertory (How much left)",
				children: order.free ? '-' : order.inventory,
				span: 3,
			},
			{
				key: "tag",
				label: "Tag",
				children: order.tag?order.tag.join(', '): '-',
				span: 3,
			},
			{
				key: "assetId",
				label: "Asset ID",
				children: order.assetId,
				span: 3,
			},
			{
				key: "asset",
				label: "Asset",
				children: order.format === 'image' 
					? <Image
						style={{maxHeight:'100px', maxWidth:'300px'}}
						src={order.asset}
						fallback="data:image/png;base64,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"
						/>
					: <video src={order.asset} width="400" controls></video>
				,
				span: 3,
			},
			{
				key: "url",
				label: "Asset Redirect URL",
				children: order.url ? <a href={order.url} target="_blank" rel="noopener noreferrer">{order.url}</a> : '-',
				span: 3,
			},
			{
				key: "package",
				label: "Parent Package",
				children: order.package,
			},
		]
        if (advertisement && order) {
            let currentTime = new Date().getTime();
            let selectedPackageStatus = new Date(advertisement.startDate).getTime() > currentTime 
                ? 'comingSoon'
                : new Date(advertisement.endDate).getTime() > currentTime
                ? 'available'
                : 'expired';
			let status = selectedPackageStatus === 'comingSoon'
				? {type: 'warning', text: 'Pending'}
				: selectedPackageStatus === 'expired'
				? {type: 'default', text: 'Expired'}
				: order.inventory > 0 || order.free
				? {type: 'processing', text: 'Running'}
				: {type: 'success', text: 'Finished'};
			let totalDisplay = advertisement.cpm === 0 ? order.budget * 1000 : order.budget * 1000 / advertisement.cpm;
			let numImpressionPaid = totalDisplay - order.inventory;
            return (
                <Animated animationIn="fadeIn">
				    <div className="orderWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
                    <Row glutter={8}>
                        <Col span={24}>
                            <div>
                                <Button type='link' style={{color: "var(--text-tertiary)", margin: "10px 10px 0"}} onClick={() => {this.backToPackage()}}><Ink /><ArrowLeftOutlined />{`Back To ${advertisement.title}`}</Button>
                            </div>
                            <Col>
                                <Row>
                                    <Col span={18} className='flex-col'>
                                        <Card className='flex-card'>
                                            <Descriptions
                                                bordered
                                                size="small"
                                                title={
                                                    <span>
                                                    {`Order Detail`}
                                                    {canEdit && <Button type="link" icon={<EditOutlined />} onClick={() => {this.toggleModal("edit", "Order")}}/>}
                                                    {canEdit && <Popconfirm
														title="Delete order"
														description="Are you sure to delete this order?"
														onConfirm={this.confirmDeleteOrder}
														okText="Yes"
														cancelText="No"
													>
														<Button className='btn-delete' type="link" danger icon={<DeleteOutlined />}/>
													</Popconfirm>}
													</span>
                                                }
                                                items={orderItems}
                                                className='orderDescription'
                                            />
                                        </Card>
                                    </Col>
                                    <Col span={6} className='flex-col'>
                                        <Card className='statusWrapper flex-card'>
                                            <div className='header first'>Status</div>
                                            <Badge status={status.type} text={status.text}/>
                                            <div className='header'>Progress</div>
                                            {
                                                order.free ?
                                                <div className='statusText'>
                                                    <div>{`-- / --`}</div>
                                                    <div className='progressWrapper'>
                                                        <Progress type="dashboard" percent={0} format={() => <span className='progress-default'>Default</span>} />
                                                    </div>
                                                </div>
                                                :
                                                <div className='statusText'>
                                                    <div>{`${numImpressionPaid || 0} / ${totalDisplay}`}</div>
                                                    <div className='progressWrapper'>
                                                        <Progress type="dashboard" percent={order.budget === 0 ? 100 :  Math.round(numImpressionPaid / totalDisplay * 100)}/>
                                                    </div>
                                                </div>
                                            }
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                       <Card style={{paddingTop: '20px'}} loading={opensearchLoading}>
										<Row gutter={16}>
											<Col span={8}>
												{
													order.free ?
													<Statistic title="Impressions" value={numImpression === false ? '0' : numImpression}/>
													:
													<Statistic title="Impressions" value={numImpressionPaid}/>
												}
											</Col>
											<Col span={8}>
												<Statistic title="Clicks" value={numClick === false ? '0' : numClick}/>
											</Col>
											<Col span={8}>
												{
													order.free ?
													<Statistic title="Clickthrough rate (CTR)" value={numImpression > 0 ? `${(numClick / numImpression * 100).toFixed(1)}%` : '0%'} />
													:
													<Statistic title="Clickthrough rate (CTR)" value={numImpressionPaid > 0 ? `${(numClick / numImpressionPaid * 100).toFixed(1)}%` : '0%'} />
												}
											</Col>
										</Row>
                                       </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Col>
                    </Row>
                    </div>
					<AddPackage
						toggleModal={this.toggleModal}
						showModal={isModalShow}
						modalType={"edit"}
						modalFrom={"Order"}
						selected={order}
					/>
                </Animated>
            )
        }
        return ""
    }
}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
    inspectionTime: state.analytics.inspectionTime,
	advertisementPackageList: state.advertisement.advertisementPackageList,
	advertisementOrderList: state.advertisement.advertisementOrderList,
	opensearchAdImpressionByIdList: state.advertisement.opensearchAdImpressionByIdList,
	opensearchCtaClickByAdIdList: state.advertisement.opensearchCtaClickByAdIdList,
	userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
      		advertisementGetPackage,
			advertisementGetOrder,
			opensearchAdImpressionIdSpecific,
			opensearchCtaClickAdIdSpecific,
			advertisementOrderDelete,
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderDetail));